<template>
    <div class="risk_table">
        <div class="header_row">
            <div class="row">
                <div class="col text-start flag_header">
                    {{ $t("overview.flags.header.0") }}
                </div>
                <div class="col col-2 col-xxl-1 text-end flag_header">
                    {{ $t("overview.flags.header.1") }}
                </div>
                <div class="col col-auto">
                    &nbsp;
                </div>
            </div>
        </div>

        <template v-for="(group, i) in flags" :key="`flag-group-${i}`">
            <div class="data_row clickable"
                @click="expanded.includes(i) ? expanded.splice(expanded.indexOf(i), 1) : expanded.push(i)"
                :class="{ clickable: clickableRows }">
                <div class="row align-items-center">
                    <div class="col text-start">
                        <RiskLevelDumpling :value="group.risk" :level="versionRiskLevel(group, version)" />

                        {{ group.name }}

                        <a v-on:click.stop="" :href="flagUrl(group.documentation_url)" target="_blank"
                            v-if="group.documentation_url">
                            <b-icon icon="question-circle" font-scale="0.95" variant="dark" class="ml-1" />
                        </a>
                    </div>
                    <div class="col col-2 text-end numeric_column">{{ formatInteger(group.count) }}x</div>
                    <div class="col col-auto" v-show="version == 'lite' || version == 'full'">
                        <IndicatorBar :widthBar="100" :value="group.percent" :tooltips="tooltips" :saveZone="saveZone"
                            :ratio="group.ratio" v-show="group.show" />
                    </div>
                    <div class="col col-auto group_caret">
                        <AnimatedCaret :expanded="expanded.includes(i)" />
                    </div>
                </div>
            </div>

            <template v-if="expanded.includes(i)">
                <div v-for="(f, j) in group['flags']" :key="`flag-${i}-${j}`" class="data_row sub"
                    :class="{ clickable: clickableRows }"
                    v-on="clickableRows ? { click: () => $emit('row-clicked', f) } : {}">
                    <div class="row align-items-center">
                        <div class="col text-start">
                            <RiskLevelDumpling :value="f.risk" :level="versionRiskLevel(f, version)" />

                            {{ f.name }}

                            <a v-on:click.stop="" :href="flagUrl(f.documentation_url)" target="_blank"
                                v-if="f.documentation_url">
                                <b-icon icon="question-circle" font-scale="0.95" variant="dark" class="ml-1" />
                            </a>
                        </div>
                        <div class="col col-2 text-end numeric_column">{{ formatInteger(f.count) }}x</div>
                        <div class="col col-auto" v-show="version == 'lite' || version == 'full'">
                            <IndicatorBar :widthBar="100" :value="f.percent" :tooltips="tooltips" :saveZone="saveZone"
                                :ratio="f.ratio" v-show="f.show" />
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import formattersMixin from "@/plugins/formattersMixin.js";
import riskMixin from "@/plugins/riskMixin.js";
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import AnimatedCaret from "@/components/AnimatedCaret.vue";
import IndicatorBar from "@/components/IndicatorBar.vue";

export default {
    name: "risks-table",
    props: {
        flags: { required: true, type: Array },
        clickableRows: { type: Boolean, default: false },
        version: { required: true }
    },
    data: function () {
        return {
            expanded: [],
            tooltips: [
                { min: 0, max: 24, title: this.$t("overview.indicator.min") },
                { min: 25, max: 50, title: this.$t("overview.indicator.bellow50") },
                { min: 50, max: 75, title: this.$t("overview.indicator.above50") },
                { min: 75, max: 101, title: this.$t("overview.indicator.max") }
            ],
            saveZone: [0, (1 / 4) * 50 + 50]
            // saveZone of indicators
            // 0 -> savezone to 0 for full gray
            // 1/4 -> range 2 (of which 0.5 1/4) and this range is 50% + 50% below range
        }
    },
    methods: {
        flagUrl(documentation_url) {
            return "https://popisrizik.datlab.eu" + documentation_url;
        }
    },
    mixins: [formattersMixin, riskMixin],
    components: { RiskLevelDumpling, AnimatedCaret, IndicatorBar }
};
</script>

<style lang="scss">
@use "@/scss/custom";

.header_row {
    padding-left: 20px;
    padding-right: 20px;
}

.data_row {
    background: #f8f8f8;
    border-radius: 8px;
    font-size: 16px;
    padding: 15px 20px;
    margin-bottom: 5px;

    .bi-circle-fill {
        margin-right: 20px;
    }

    &.sub {
        margin-left: 40px;
    }
}

.data_row.clickable:hover {
    background-color: rgb(226, 226, 226);
}

.last_column {
    padding-right: 20px;
}

.group_caret {
    font-size: 12px;
    line-height: 12px;
}
</style>
